export default __webpack_public_path__ + "static/media/banner1.72b38d28.webp";